export default __webpack_public_path__ + "images/0xaae0c3856e665ff9b3e2872b6d75939d810b7e40.png";